import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router';
import Logo2 from '../assets/newlogo.svg';

export default function Header() {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    const go = (path: string) => {
        setMenuOpen(false);
        navigate(path);
    };

    return (
        <header className="bg-white px-4 md:px-8 lg:px-12 py-3 md:py-4 flex items-center justify-between shadow-sm sticky top-0 z-50">
            {/* Left Navigation */}
            <nav className="hidden lg:flex items-center gap-6 xl:gap-10">
                <a href="/" className="text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600">
                    Home
                </a>
                <a href="/blog" className="text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600">
                    Blog
                </a>
            </nav>

            {/* Mobile Menu Button */}
            <button
                type="button"
                aria-label="Toggle menu"
                aria-expanded={menuOpen}
                onClick={() => setMenuOpen((open) => !open)}
                className="lg:hidden text-gray-900"
            >
                {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>

            {/* Center Logo */}
            <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center gap-2">
                <img src={Logo2} alt="YourChecka Logo" className="h-8 md:h-9 w-auto" />
            </div>

            {/* Right Navigation */}
            <div className="hidden md:flex items-center gap-3 lg:gap-6">
                <button
                    onClick={() => navigate('/signup')}
                    className="hidden lg:block text-gray-900 text-[14px] xl:text-[15px] font-normal hover:text-gray-600"
                >
                    Sign Up
                </button>
                <button
                    onClick={() => navigate('/login')}
                    className="bg-black text-white px-4 md:px-5 lg:px-7 py-2 md:py-2.5 rounded-full text-[13px] md:text-[15px] font-medium hover:bg-gray-900 transition-colors"
                >
                    Login
                </button>
            </div>

            {/* Mobile Login Button */}
            <button
                onClick={() => navigate('/login')}
                className="md:hidden bg-black text-white px-4 py-2 rounded-full text-[13px] font-medium"
            >
                Login
            </button>

            {/* Mobile Menu Panel */}
            {menuOpen && (
                <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg flex flex-col py-2">
                    <button
                        type="button"
                        onClick={() => go('/')}
                        className="text-left text-gray-900 text-[15px] font-normal px-6 py-3 hover:bg-gray-50"
                    >
                        Home
                    </button>
                    <button
                        type="button"
                        onClick={() => go('/blog')}
                        className="text-left text-gray-900 text-[15px] font-normal px-6 py-3 hover:bg-gray-50"
                    >
                        Blog
                    </button>
                    <button
                        type="button"
                        onClick={() => go('/signup')}
                        className="text-left text-gray-900 text-[15px] font-normal px-6 py-3 hover:bg-gray-50"
                    >
                        Sign Up
                    </button>
                    <button
                        type="button"
                        onClick={() => go('/login')}
                        className="text-left text-gray-900 text-[15px] font-normal px-6 py-3 hover:bg-gray-50"
                    >
                        Login
                    </button>
                </div>
            )}
        </header>
    );
}
